export const TextContentData = [
    {
        heading: 'Who We Are',
        content:
            'Dr. Mohammed Audu Rehab Centre (DMARC) is a leading facility dedicated to the treatment and rehabilitation of individuals struggling with substance use disorders and behavioral challenges.',
    },
    {
        heading: 'Our Mission',
        content:
            'We are dedicated to restoring dignity and hope to those battling substance use disorders. Through compassionate care and professional treatment, we empower individuals to regain control of their lives and build a healthier future.',
    },
];
